<script setup>
import { useRouter } from 'vue-router'
import { formatDate } from 'Common/utils/formatDate'
import MissionStatusIndicator from 'Modules/components/feedback/MissionStatusIndicator.vue'
import { JeteyeRoutes } from 'Modules/RouterSetup'

const props = defineProps({
  data: { type: Array, default: () => [] },
})
const router = useRouter()
const rowClick = (row) => {
  const aircraftUuid = row.aircraftUuid
  const inspectionInstanceUuid = row.inspectionInstanceUuid
  router.push({
    name: JeteyeRoutes.SummaryReport,
    query: {
      aircraft: [aircraftUuid],
      inspectionInstance: [inspectionInstanceUuid],
    },
  })
}

// return a formatted update date for the last activity column
const formatUpdatedColumn = (row) => {
  return formatDate(row.updateDate)
}
</script>

<template>
  <el-table :data="props.data" :stripe="true" row-class-name="hover:cursor-pointer" height="99%" @row-click="rowClick">
    <el-table-column prop="type" label="Type" sortable />
    <el-table-column prop="label" label="Label" sortable />
    <el-table-column prop="tailNumber" label="Tail Number" sortable />
    <el-table-column prop="aircraftFrame" label="Air Frame" sortable />
    <el-table-column prop="status" label="Status" sortable>
      <template #default="scope">
        <MissionStatusIndicator :status="scope.row.status" />
      </template>
    </el-table-column>
    <el-table-column prop="updateDate" label="Last Activity" sortable :formatter="formatUpdatedColumn" />
    <el-table-column prop="openInspections" label="Open Inspections" sortable />
    <!--el-table-column prop="comments" label="Comments" sortable /-->
    <template #empty>
      <div class="h-full w-full flex items-center justify-center">No Data</div>
    </template>
  </el-table>
</template>
